import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
}

const TourAlertMessageModal: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.6)", // strong backdrop
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          width: 300,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={1}>
          Important Note
        </Typography>

        <Typography
          variant="body2"
          fontWeight={500}
          mb={1}
        >
          Submit Tour Program by <strong>25th</strong> & get approved by Manager by <strong>28th</strong>
        </Typography>

        <Typography
          variant="body2"
          color="error.main"
          fontWeight={500}
          mb={3}
        >
          Avoid any deviations from TP
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default TourAlertMessageModal;
